import { Size } from '../../common/types';
import apiClient from '../apiClient';


export const findProductSizes = async (
    firestoreId: string,
    brandCode: string,
    typeLabelLong: string,
    genderCode: string,
    userUid?: string,
    allowLiveScrape?: boolean
): Promise<Size[]> => {
    try {
        const response = await apiClient(
            '/cf/find_product_sizes',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    firestore_id: firestoreId,
                    brand_code: brandCode,
                    type_label_long: typeLabelLong,
                    gender_code: genderCode,
                    user_uid: userUid,
                    allow_live_scrape: allowLiveScrape,
                }),
            }
        );
        const sizes: Size[] = response.map((sizeStr: string) => ({ label: sizeStr }));
        return sizes;
    } catch (error) {
        console.error('Failed to fetch sizes by brand', error);
        return [];
    }
};